module.exports = __webpack_public_path__ + "static/media/spinnerGlobal.aa2aa0b6.gif";